import { Diagram, Overview, Spot } from 'gojs';

export enum GoJsOverviewPosition {
  Left,
  Right,
  RightWithSidebar,
}

export const GoJsOverviewPositionToClass: Record<GoJsOverviewPosition, string> = {
  [GoJsOverviewPosition.Left]: 'left-[30px]',
  [GoJsOverviewPosition.Right]: 'right-[30px]',
  [GoJsOverviewPosition.RightWithSidebar]: 'right-[100px]',
};

export const gojsOverview = (referencedDiagram: Diagram): Overview => {
  const myOverview = new Overview();
  myOverview.observed = referencedDiagram;
  myOverview.contentAlignment = Spot.Center;

  return myOverview;
};
